import { render } from "./Entertainment.vue?vue&type=template&id=407859fe&scoped=true"
import script from "./Entertainment.vue?vue&type=script&lang=js"
export * from "./Entertainment.vue?vue&type=script&lang=js"

import "./Entertainment.vue?vue&type=style&index=0&id=407859fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-407859fe"

export default script